export { Calculations } from './lib/calculations'
export { btdetect } from './lib/bot-detector'
